document.addEventListener("alpine:init", () => {
  const PENDANT_SCALE = 0.30;
  const extraPendant_SCALE = 0.23;
  
  Alpine.data('buildYourOwn', (options) => ({
    metal: options.metal,
    necklaceBase: options.necklaceBase,
    showHelp: true,
    pendant: null,
    extraPendants: [],
    addons: [],

    price: 0.0,
    compare_at_price: 0.0,
    extraPendantsPrice: {},
    
    canvas: null,
    baseImage: null,
    pendantObject: null,
    extraPendantObjects: {},
    
    initialCanvasWidth: 0,
    initialCanvasHeight: 0,
    
    fixedPositions: {
      1: [ { x: 0.50, y: 0.35, a: 0 } ],
      2: [ { x: 0.47, y: 0.34, a: 5 }, { x: 0.53, y: 0.34, a: -5 } ],
      3: [ 
        { x: 0.43, y: 0.34, a: 10 }, 
        { x: 0.50, y: 0.35, a: 0 }, 
        { x: 0.56, y: 0.33, a: -10 } 
      ],
      4: [
        { x: 0.41, y: 0.30, a: 15 }, 
        { x: 0.46, y: 0.33, a: 5 }, 
        { x: 0.54, y: 0.33, a: -5 }, 
        { x: 0.59, y: 0.30, a: -15 } 
      ],
    },
    
    init() {
      this.canvas = new fabric.Canvas('necklace-canvas', {
        preserveObjectStacking: true,
        backgroundColor: '#f0f0f0',
        selection: false,
        perPixelTargetFind: true,
      });
      
      this.resizeCanvas();
      this.setupEventListeners(); 
      window.addEventListener('resize', () => this.resizeCanvas());

      this.loadBaseImage();

      this.$watch('pendant', () => {
        this.getPrice();

        if (this.pendant) {
          this.showHelp = false;
        }
      });

      this.$watch('extraPendants', () => {
        this.getPrice();

        if (this.extraPendants.length > 0) {
          this.showHelp = false;
        }
      });
    },

    addToCart() {
      const itemsToCart = [];
      const byoPropertyValue = Date.now();

      if (this.pendant) {
        itemsToCart.push({
          id: this.pendant.variantId,
          quantity: 1,
          properties: {
            '__byo': byoPropertyValue,
            '__metal': this.metal
          }
        });
      }

      this.extraPendants.forEach(extraPendant => {
        itemsToCart.push({
          id: extraPendant.variantId,
          quantity: 1,
          properties: {
            '__byo': byoPropertyValue,
            '__metal': this.metal
          }
        });
      });

      this.addons.forEach(addon => {
        itemsToCart.push({
          id: addon.variantId,
          quantity: 1,
          properties: {
            '__byo': byoPropertyValue,
            '__metal': this.metal
          }
        });
      });
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToCart })
      })
      .then(response => response.json())
      .then(data => {
        this.$dispatch('cart:refresh');
        this.$dispatch('toggle-cart-drawer');
      })
      .catch((error) => {
        alert('Error: please try again');
        console.error('Error adding to cart:', error);
      });
    },

    getPrice() {
      let mainPendantTotal = 0;
      let mainPendantCompare = 0;
      let extraPendantsTotal = 0;
      let extraPendantsCompare = 0;
      let addonsTotal = 0;
      let addonsCompare = 0;

      if (this.pendant && this.pendant.price) {
        mainPendantTotal = this.pendant.price;
        mainPendantCompare = this.pendant.compare_at_price || this.pendant.price;
      }

      this.extraPendants.forEach(ep => {
        extraPendantsTotal += ep.price;
        extraPendantsCompare += (ep.compare_at_price || ep.price);
      });

      this.addons.forEach(addon => {
        addonsTotal += addon.price;
        addonsCompare += (addon.compare_at_price || addon.price);
      });

      const total = mainPendantTotal + extraPendantsTotal + addonsTotal;
      const compareTotal = mainPendantCompare + extraPendantsCompare + addonsCompare;

      this.price = total;
      this.compare_at_price = compareTotal;
      this.extraPendantsPrice = { price: extraPendantsTotal, compare_at_price: extraPendantsCompare };
    },

    setupEventListeners() {
      this.canvas.on('object:modified', (e) => {
        if (e.target) {
          e.target.bringToFront();
        }
        this.centerItemsAfterDrag(e.target); 
      });
      
      this.canvas.on('object:moving', (e) => {
        this.rotateObjectOnDrag(e.target);
      });
      this.canvas.on('mouse:down', (e) => {
        this.handleObjectStart(e); 
      });
      
      this.canvas.on('mouse:up', (e) => {
        this.handleObjectClickOrDrag(e); 
      });
    },

    handleObjectStart(e) {
      const clickedObject = e.target;
      
      if (!clickedObject || clickedObject === this.baseImage) {
        return;
      }
      
      clickedObject.initialClickX = clickedObject.left;
      clickedObject.initialClickY = clickedObject.top;
    },
    
    handleObjectClickOrDrag(e) {
      const releasedObject = e.target;

      if (!releasedObject || releasedObject === this.baseImage) {
        return;
      }
      
      const startX = releasedObject.initialClickX;
      const startY = releasedObject.initialClickY;
      const endX = releasedObject.left;
      const endY = releasedObject.top;
      
      const distanceMoved = Math.sqrt(
        Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2)
      );
      
      const CLICK_TOLERANCE = 5; 
      
      if (distanceMoved < CLICK_TOLERANCE) {
        this.removeObject(releasedObject);
      } 
    },
    
    removeObject(clickedObject) {
      const clickedVariantId = clickedObject.customVariantId;
      const clickedType = clickedObject.customType;

      let removed = false;

      if (clickedType === 'pendant' && this.pendant && this.pendant.variantId === clickedVariantId) {
        this.removePendant();
        this.pendant = null;
        removed = true;
      } 
      
      else if (clickedType === 'extraPendant') {
        const variantIdToRemove = clickedVariantId;

        if (this.extraPendantObjects[variantIdToRemove]) {
          this.removeExtraPendant(variantIdToRemove);
          removed = true;
        }
      }

      if (removed) {
        this.getPrice(); 
        this.canvas.renderAll();
      }
    },

    rotateObjectOnDrag(obj) {
      if (!obj) return;
      
      const centerX = this.initialCanvasWidth / 2;
      const deviation = obj.left - centerX;
      const rotationSensitivity = 0.1;
      
      let newAngle = -deviation * rotationSensitivity;
      
      newAngle = Math.max(-10, Math.min(10, newAngle));
      
      obj.set({ angle: newAngle });
      this.canvas.renderAll();
    },

    centerItemsAfterDrag(modifiedObject) {
      const movableObjects = [this.pendantObject, ...Object.values(this.extraPendantObjects)].filter(Boolean);
      const count = movableObjects.length;
      
      if (count === 0 || !this.fixedPositions[count]) {
        this.canvas.renderAll();
        return;
      }
      
      movableObjects.sort((a, b) => a.left - b.left);
      
      const fixedCoords = this.fixedPositions[count];
      let animationCount = 0;
      const totalAnimations = movableObjects.length;
      
      movableObjects.forEach((obj, index) => {
        const coords = fixedCoords[index];
        
        const targetLeft = this.initialCanvasWidth * coords.x;
        const targetTop = this.initialCanvasHeight * coords.y;
        const targetAngle = coords.a;
        
        fabric.util.animate({
            startValue: 0,
            endValue: 1,
            duration: 300,
            easing: fabric.util.ease.easeOutQuad,
            onChange: (value) => {
                const newLeft = obj.left + (targetLeft - obj.left) * value;
                const newTop = obj.top + (targetTop - obj.top) * value;
                const newAngle = obj.angle + (targetAngle - obj.angle) * value;

                obj.set({ 
                    left: newLeft, 
                    top: newTop, 
                    angle: newAngle 
                });
                obj.setCoords();
                this.canvas.renderAll();
            },
            onComplete: () => {
                animationCount++;
                if (animationCount === totalAnimations) {
                    obj.set({ 
                        left: targetLeft, 
                        top: targetTop, 
                        angle: targetAngle 
                    });
                    obj.setCoords();
                    this.canvas.renderAll();
                }
            }
        });
      });
    },

    snapItemsToFixedPositions() {
      const movableObjects = [this.pendantObject, ...Object.values(this.extraPendantObjects)].filter(Boolean);
      const count = movableObjects.length;

      if (count === 0 || !this.fixedPositions[count]) {
        return;
      }

      movableObjects.sort((a, b) => a.left - b.left);

      const fixedCoords = this.fixedPositions[count];

      movableObjects.forEach((obj, index) => {
        const coords = fixedCoords[index];
        
        const targetLeft = this.initialCanvasWidth * coords.x;
        const targetTop = this.initialCanvasHeight * coords.y;
        const targetAngle = coords.a;

        obj.set({ 
          left: targetLeft, 
          top: targetTop, 
          angle: targetAngle 
        });
        obj.setCoords();
      });
    },

    resizeCanvas() {
      const wrapper = document.getElementById('canvas-wrapper');
      const currentWidth = wrapper.clientWidth;
      const currentHeight = currentWidth;

      let scaleFactor = 1;
      if (this.initialCanvasWidth !== 0) {
        scaleFactor = currentWidth / this.initialCanvasWidth;
      }

      this.canvas.setWidth(currentWidth);
      this.canvas.setHeight(currentHeight);
      
      const customObjects = [this.pendantObject, ...Object.values(this.extraPendantObjects)].filter(Boolean);
      if (this.baseImage) {
        customObjects.push(this.baseImage);
      }

      customObjects.forEach(obj => {
        if (this.initialCanvasWidth !== 0) {
          obj.set({
            left: obj.left * scaleFactor,
            top: obj.top * scaleFactor,
            scaleX: obj.scaleX * scaleFactor,
            scaleY: obj.scaleY * scaleFactor
          });
          obj.setCoords(); 
        }
      });

      if (this.baseImage) {
        const newBaseScale = currentWidth / this.baseImage.getOriginalSize().width;
        this.baseImage.set({ 
          scaleX: newBaseScale, 
          scaleY: newBaseScale,
          left: currentWidth / 2 
        });
      }
      
      this.initialCanvasWidth = currentWidth;
      this.initialCanvasHeight = currentHeight;
      
      this.snapItemsToFixedPositions(); 

      this.canvas.renderAll();
    },

    _addItemToCanvas(itemData, type) {
      const targetRelativeScale = (type === 'pendant') ? PENDANT_SCALE : extraPendant_SCALE;

      fabric.Image.fromURL(itemData.image, (img) => {
        const imageOriginalWidth = img.getOriginalSize().width;
        
        const calculatedScale = (targetRelativeScale * this.initialCanvasWidth) / imageOriginalWidth;

        img.set({
          top: this.initialCanvasHeight * 0.35, 
          left: this.initialCanvasWidth * 0.5,
          originX: 'center',
          originY: 'top',
          scaleX: calculatedScale,
          scaleY: calculatedScale,
          hasControls: false, 
          hasBorders: false,
          lockRotation: true,
          lockMovementY: false,
          lockMovementX: false,
          angle: 0,
          customVariantId: itemData.variantId,
          customType: type,
        });

        if (type === 'pendant') {
          this.pendantObject = img;
          this.pendant = itemData;
          this.canvas.add(img);
        } else {
          this.extraPendantObjects[itemData.variantId] = img;
          this.extraPendants.push(itemData);
          this.canvas.add(img);
          this.canvas.bringToFront(img);
        }

        this.centerItemsAfterDrag(img); 
      }, { crossOrigin: 'anonymous' });
    },

    loadBaseImage() {
      if (this.baseImage) {
        this.canvas.remove(this.baseImage);
        this.baseImage = null;
      }

      fabric.Image.fromURL(this.necklaceBase, (img) => {
        this.baseImage = img;
        
        const initialScale = this.initialCanvasWidth / img.width;

        img.set({
          selectable: false, 
          evented: false,
          scaleX: initialScale,
          scaleY: initialScale,
          left: this.initialCanvasWidth / 2,
          top: this.initialCanvasHeight * 0.18,
          originX: 'center',
          originY: 'center',
        });
        
        this.canvas.add(img);
        this.canvas.sendToBack(img);
        this.canvas.renderAll();
      }, { crossOrigin: 'anonymous' });
    },

    togglePendant(pendantData) {
      if (this.pendant && this.pendant.variantId === pendantData.variantId) {
        this.removePendant();
        this.pendant = null;
      } else {
        this.removePendant();
        this.addPendant(pendantData);
      }

      if (pendantData.necklaceBase) {
        this.necklaceBase = pendantData.necklaceBase;
        this.loadBaseImage();
      }
    },
    
    addPendant(pendantData) {
      this.pendantObject = null;
      this._addItemToCanvas(pendantData, 'pendant'); 
    },
    
    removePendant() {
      if (this.pendantObject) {
        this.canvas.remove(this.pendantObject);
        this.pendantObject = null;
        this.centerItemsAfterDrag();
      }
    },

    toggleExtraPendant(extraPendantData) {
      const variantId = extraPendantData.variantId;

      const length = Object.keys(this.extraPendantObjects).length;
      
      if (this.extraPendantObjects[variantId]) {
        this.removeExtraPendant(variantId);
      } else if (length < 2) {
        this.addExtraPendant(extraPendantData);
      }
    },
    
    addExtraPendant(extraPendantData) {
      this._addItemToCanvas(extraPendantData, 'extraPendant');
    },
    
    removeExtraPendant(variantId) {
      const objToRemove = this.extraPendantObjects[variantId];
      if (objToRemove) {
        this.canvas.remove(objToRemove);
        
        delete this.extraPendantObjects[variantId];
        this.extraPendants = this.extraPendants.filter(extraPendant => extraPendant.variantId !== variantId);
        
        this.centerItemsAfterDrag();
      }
    },

    handleDragStart(e, itemData) {
      e.dataTransfer.setData('application/json', JSON.stringify(itemData));
    },
    
    handleDragOver(e) {
      e.preventDefault();
    },
    
    handleDrop(e) {
      e.preventDefault();
      
      const dataString = e.dataTransfer.getData('application/json');
      if (!dataString) return;
      
      try {
        const itemData = JSON.parse(dataString);

        if (itemData.necklaceBase) {
          this.necklaceBase = itemData.necklaceBase;
          this.loadBaseImage();
        }
        
        const pointer = this.canvas.getPointer(e, false);
        
        this._addItemToCanvasFromDrop(itemData, pointer.x, pointer.y);
        
      } catch (error) {
        console.error('Error parsing dropped data:', error);
      }
    },
    
    _addItemToCanvasFromDrop(itemData, dropX, dropY) {
      const type = itemData.type;
      const targetRelativeScale = (type === 'pendant') ? PENDANT_SCALE : extraPendant_SCALE;
      
      fabric.Image.fromURL(itemData.image, (img) => {
        const imageOriginalWidth = img.getOriginalSize().width;
        
        const calculatedScale = (targetRelativeScale * this.initialCanvasWidth) / imageOriginalWidth;

        img.set({
          top: dropY, 
          left: dropX,
          originX: 'center',
          originY: 'top',
          scaleX: calculatedScale,
          scaleY: calculatedScale,
          hasControls: false, 
          hasBorders: false,
          lockRotation: true,
          lockMovementY: false,
          lockMovementX: false,
          angle: 0,
          customVariantId: itemData.variantId,
          customType: type,
        });

        if (type === 'pendant') {
          this.removePendant();
          this.pendantObject = img;
          this.pendant = itemData;
          this.canvas.add(img);
          
          this.$nextTick(() => {
            const button = this.$el.querySelector(`.builder-option__button[data-variant-id="${itemData.variantId}"]`);
            if (button) button.classList.add('is-selected');
          });
          
        } else if (type === 'extraPendant') {
          const length = Object.keys(this.extraPendantObjects).length;
          
          if (length >= 2) {
            alert("You can only add a maximum of 2 additional pendants.");
            return;
          }
          
          if (this.extraPendantObjects[itemData.variantId]) {
            return; 
          }
          
          this.extraPendantObjects[itemData.variantId] = img;
          this.extraPendants.push(itemData);
          this.canvas.add(img);
          this.canvas.bringToFront(img);
          
          this.$nextTick(() => {
            const button = this.$el.querySelector(`.builder-option__button[data-variant-id="${itemData.variantId}"]`);
            if (button) button.classList.add('is-selected');
          });
        }
        
        this.centerItemsAfterDrag(img); 
      }, { crossOrigin: 'anonymous' });
    },

    toggleAddonProduct(variantId, price, compareAtPrice) {
      const exists = this.addons.some(item => item.variantId === variantId);

      if (exists) {
        this.addons = this.addons.filter(item => item.variantId !== variantId);
      } else {
        this.addons.push({ 
          variantId: variantId, 
          price: price, 
          compare_at_price: compareAtPrice 
        });
      }
      
      this.getPrice(); 
    },
  }));
});